module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Enlightened")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("I don’t know if I can remain friends with her. I’ve thought and thought about it—she’ll never know how much. I gave it one last try. I called her, after a year. But I didn’t like the way the conversation went. The problem is that she is not very enlightened. Or I should say, she is not enlightened enough for me. She is nearly fifty years old and no more enlightened, as far as I can see, than when I first knew her twenty years ago, when we talked mainly about men. I did not mind how unenlightened she was then, maybe because I was not so enlightened myself. I believe I am more enlightened now, and certainly more enlightened than she is, although I know it’s not very enlightened to say that. But I want to say it, so I am willing to postpone being more enlightened myself so that I can still say a thing like that about a friend.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bb0fc4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781466806276_ch03.vue
// module id = 81
// module chunks = 0